import WaveAndWind from 'components/MarineForecast/WaveAndWind';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SurfAlerts from 'components/MarineForecast/SurfAlerts';
import BuoyConditions from 'components/MarineForecast/BuoyConditions';
import TideTable from 'components/MarineForecast/TideTable';
import { usePerms } from 'contexts/PermsContext';
import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import { Container } from 'react-bootstrap';

const daysOfWeekMap = new Map([
  ['sunday', 0],
  ['monday', 1],
  ['tuesday', 2],
  ['wednesday', 3],
  ['thursday', 4],
  ['friday', 5],
  ['saturday', 6],
]);

const daysOfWeekArray = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

const topTabs = [
  { option: 'Wave and Wind Conditions' },
  { option: 'Surf Alerts' },
  { option: 'Buoy Conditions' },
  { option: 'Tide Table' },
];

const bottomTabs = [
  { option: 'Sunday' },
  { option: 'Monday' },
  { option: 'Tuesday' },
  { option: 'Wednesday' },
  { option: 'Thursday' },
  { option: 'Friday' },
  { option: 'Saturday' },
];

export default function MarineForecast() {
  const [params, setParams] = useSearchParams();
  const perms = usePerms();
  const [tab, setTab] = useState(params.get('tab')?.toLowerCase());
  const [day, setDay] = useState(params.get('day')?.toLowerCase());
  const navigate = useNavigate();

  useEffect(() => {
    if (!tab)
      setParams({
        tab: 'Wave and Wind Conditions',
        day: daysOfWeekArray[new Date().getDay()],
      });
    (async () => {
      if (!(await perms.validatePermissions(['MarineForecastEnabled']))) {
        navigate('/404');
        return;
      }
    })();
  }, []);

  useEffect(() => {
    setTab(params.get('tab')?.toLowerCase());
    setDay(params.get('day')?.toLowerCase());
  }, [params]);

  const renderTab = () => {
    switch (tab) {
      case 'wave and wind conditions':
        return <WaveAndWind tab={daysOfWeekMap.get(day) || 0} />;
      case 'surf alerts':
        return <SurfAlerts />;
      case 'buoy conditions':
        return <BuoyConditions />;
      case 'tide table':
        return <TideTable />;
      default:
        return <WaveAndWind tab={daysOfWeekMap.get(day) || 0} />;
    }
  };
  return (
    <Container fluid className="d-flex flex-column h-100 py-3">
      {/* header */}
      <div className="d-none d-lg-block">
        <TabsHeader
          depth={0}
          borderRadius={tab === 'wave and wind conditions' ? '8px 8px 0 0' : '8px'}
          options={topTabs}
        />
        {tab === 'wave and wind conditions' && (
          <TabsHeader
            param="day"
            borderRadius={'0 0 8px 8px'}
            options={bottomTabs}
            variant="primary"
          />
        )}
      </div>
      <div className="d-block d-lg-none">
        <MobileTabsHeader options={topTabs} />
        {tab === 'wave and wind conditions' && (
          <MobileTabsHeader param="day" options={bottomTabs} />
        )}
      </div>
      <div style={{ height: 'calc(100% - 48px)' }}>{renderTab()}</div>
    </Container>
  );
}
